import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M26.36 24.007c.273.023.537.104.776.237l10.598 5.878a1.576 1.576 0 0 1 0 2.757L27.13 38.756a1.94 1.94 0 0 1-2.637-.755l-.088-.181-.07-.19a2.011 2.011 0 0 1-.078-.403A65.504 65.504 0 0 1 24 31.532c.001-1.806.089-3.725.262-5.757a1.94 1.94 0 0 1 2.098-1.768ZM24 9c8.285 0 15 6.715 15 15 0 .913-.305 1.907-.83 2.932l-.764-.423c.151-.813.23-1.652.23-2.509 0-7.532-6.104-13.636-13.636-13.636-7.532 0-13.636 6.104-13.636 13.636 0 6.593 4.677 12.092 10.895 13.36l.01.127c.04.451.14.894.3 1.316C14.44 37.643 9 31.458 9 24c0-8.285 6.715-15 15-15Zm0 6.903a8.096 8.096 0 0 1 8.085 7.654L28.59 21.62a4.94 4.94 0 0 0-7.318 3.9A71.282 71.282 0 0 0 21 31.53c-2.987-1.2-5.097-4.118-5.097-7.53A8.096 8.096 0 0 1 24 15.903Z",
      clipRule: "evenodd"
    }
  )
);
var SvgRecordingResumeOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var RecordingResumeOutlined_default = SvgRecordingResumeOutlined;

export { RecordingResumeOutlined_default as default };
